import {
    useState,
    useCallback,
    useEffect
} from 'react';
import {
    Container,
    Content,
    Tag,
    Card,
    ViewCategory,
    NewCategory,
    BtnSave
} from './styled';
import { api } from '../../../../service/api';
import { Modal } from '../../../../components';
import { IoIosAdd } from 'react-icons/io';
import { toast } from 'react-toastify';



export function Categories() {


    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState({});
    const [renderModal, setRenderModal] = useState(false);

    const searchCategories = useCallback(async () => {
        const { data } = await api.get(`/categories`);
        setCategories(data)
    }, []);
    useEffect(() => {
        searchCategories()
    }, [searchCategories])

    function handleCreatCategory() {
        setSelectedCategory({});
        setRenderModal('creat');
    };
    function handleEditCategory(category) {
        setSelectedCategory(category);
        setRenderModal('edit');
    };

    const RenderViewCategory = ({ category }) => {
        return (
            <ViewCategory
                key={category?.id}
                onClick={() => { handleEditCategory(category) }}
            >
                <Card
                    color={category?.color_rgb}
                >
                    <div className='category'>
                        <Tag color={category?.color_rgb}>
                            {category?.name}
                        </Tag>
                        <Tag color={category?.color_rgb}>
                            {`Prioridade ${category?.priority}`}
                        </Tag>
                    </div>
                    <div className='description'>
                        <p>{
                            category?.description
                                ? category?.description
                                : 'Não há descrição'
                        }</p>
                    </div>
                </Card>
            </ViewCategory>
        )
    };
    const RenderCategory = () => {
        const [inLoading, setInLoading] = useState(false);
        const [name, setName] = useState(selectedCategory?.name || '');
        const [priority, setPriority] = useState(selectedCategory?.priority || '');
        const [color_rgb, setColor_rgb] = useState(selectedCategory?.color_rgb || '#d3d3d3');
        const [description, setDescription] = useState(selectedCategory?.description || '');

        async function handleSaveCategory() {
            setInLoading(true);
            if (!name) {
                toast.warning('Por favor insira um nome para a categoria !',
                    { position: "top-center", theme: "colored" }
                );
                setInLoading(false);
                return
            }
            if (!priority) {
                toast.warning('Por favor informe a prioridade',
                    { position: "top-center", theme: "colored" }
                ); setInLoading(false);
                return
            }
            if (!color_rgb || color_rgb === '#d3d3d3') {
                toast.warning('Por favor escolha uma cor',
                    { position: "top-center", theme: "colored" }
                ); setInLoading(false);
                return
            }
            const { status } = renderModal === 'creat'
                ? await api.post(`/categories`,
                    {
                        name,
                        priority,
                        color_rgb,
                        description
                    }
                )
                : await api.put(`/categories`,
                    {
                        id: selectedCategory?.id,
                        name,
                        priority,
                        color_rgb,
                        description
                    }
                )
            setInLoading(false)
            if (status === 201 || status === 200) {
                toast.success('Categoria Salva !',
                    { position: "top-center", theme: "colored" }
                );
                searchCategories();
                setRenderModal(false);
            } else {
                toast.error('Erro ao salvar  !',
                    { position: "top-center", theme: "colored" }
                );
            }
            return
        }
        return (
            <NewCategory inLoading={inLoading}>
                <div className='preview--'>
                    <Card
                        color={color_rgb}
                        className='card'
                    >
                        <div className='category'>
                            <Tag color={color_rgb}>
                                {
                                    name
                                        ? name
                                        : 'Nome Categoria'
                                }
                            </Tag>
                            <Tag color={color_rgb}>
                                {`Prioridade ${priority}`}
                            </Tag>
                        </div>
                        <div className='description'>
                            <p>{
                                description
                                    ? description
                                    : 'Não há descrição'
                            }</p>
                        </div>
                    </Card>
                </div>
                <div className='actions--'>
                    <div className='line--'>
                        <div className='action--1'>
                            <input
                                type="text"
                                placeholder='Nome da categoria...'
                                name="name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                        <div className='action--2'>
                            <input
                                type="number"
                                max={10}
                                min={1}
                                placeholder='Prioridade N.º'
                                name="priority"
                                value={priority}
                                onChange={(e) => setPriority(parseInt(e.target.value, 10))}
                            />
                        </div>
                        <div className='action--2'>
                            {'Selecione uma cor'}
                            <input
                                type="color"
                                name='color_rgb'
                                value={color_rgb}
                                onChange={(e) => setColor_rgb(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='line--'>
                        <div className='action--3'>
                            <input
                                type="text"
                                placeholder='Descrição...'
                                name='description'
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='save--'>
                        <BtnSave onClick={() => { handleSaveCategory() }}>
                            Salvar
                        </BtnSave>
                    </div>
                </div>
            </NewCategory>
        )
    };

    return (
        <Container>
            <Content>
                <div className='box--1'>
                    <div>
                        <button onClick={() => { handleCreatCategory() }}>
                            <IoIosAdd fontSize={'1.5rem'} /> Nova Categoria
                        </button>
                    </div>
                </div>
                {categories.length > 0 &&
                    (<ul className='list'>
                        {categories.map((category) => {
                            return (<RenderViewCategory
                                key={category.id}
                                category={category}
                            />)
                        })}
                    </ul>)
                }
            </Content>
            <Modal
                title={`${renderModal === 'creat'
                    ? 'Nova'
                    : 'Editar'
                    } Categoria`}
                isOpen={renderModal}
                close={() => setRenderModal(false)}
            >
                <RenderCategory />
            </Modal>
        </Container >
    );
}
